class HeroScroll extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.isTicking = false

    this.updateEl = this.updateEl.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()

    this.buttonEl = this.els?.button?.element

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.buttonEl = this.els?.button?.element
    this.handleButtonClick = this.handleButtonClick.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll.bind(this))
    this.listeners.add(this.buttonEl, 'click', this.handleButtonClick)
  }

  onScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    if (!this.buttonEl) return

    const buttonRect = this.buttonEl.getBoundingClientRect()
    const viewportHeight = window.innerHeight

    const fadeZoneStart = viewportHeight * 0.25 // top 25% of screen
    const distanceFromTop = buttonRect.top

    let opacity = 1

    if (distanceFromTop <= fadeZoneStart) {
      const progress = Math.min(
        Math.max((fadeZoneStart - distanceFromTop) / fadeZoneStart, 0),
        1,
      )

      opacity = 1 - progress
    }

    this.buttonEl.style.opacity = opacity
    this.buttonEl.style.pointerEvents = opacity === 0 ? 'none' : 'auto'
  }

  handleButtonClick () {
    const nextSection = this.nextSection

    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' })
    }
  }

  get nextSection () {
    const currentSection = this.closest(this.sectionSelector)

    let candidate = currentSection?.nextElementSibling

    while (candidate?.matches(this.sectionSelector)) {
      const position = window.getComputedStyle(candidate).position

      if (position !== 'fixed' && position !== 'absolute') break

      candidate = candidate.nextElementSibling
    }

    return candidate?.matches(this.sectionSelector) ? candidate : null
  }

  get sectionSelector () {
    return `.shopify-section`
  }
}

if (!customElements.get('hero-scroll')) {
  customElements.define('hero-scroll', HeroScroll)
}
